export default function cleanProjectName(name) {
  return name
    .replace(/\s+/g, " ")
    .replace(/\/+/g, "/")
    .replace(/^\s+|\s+$/g, "")
    .replace(/^\/+|\/+$/g, "");
}
